import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  error: null,
  isFetching: false,
  courses: {},
}

const reducers = {
  fetchingCourseTree: (state, { payload }) => {
    const { courseStateKey } = payload
    state.error = null
    state.isFetching = true
    if (!state.courses[courseStateKey]) {
      state.courses[courseStateKey] = {}
    }
  },

  fetchCourseTreeError: (state, { payload }) => {
    const { courseStateKey, error } = payload
    state.error = error
    state.isFetching = false
    if (state.courses[courseStateKey]) {
      state.courses[courseStateKey].error = error
    }
  },

  fetchCourseTreeSuccess: (state, { payload }) => {
    const { courseStateKey, data } = payload
    state.error = null
    state.isFetching = false
    state.courses[courseStateKey] = { data }
  },

  clearErrors: state => {
    state.error = null
  },
}

const slice = createSlice({
  initialState,
  name: 'curriculumCourse',
  reducers,
})

export const actions = slice.actions
export default slice.reducer
